import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { fetchData, trackPageView } from "@/lib/helper";
import { useRecoilState } from "recoil";
import { userDataAtom } from "@/recoil/atom/userDataAtom";
import NewHomeScreen from "@/components/journey/NewHome";
import StartScreen from "@/components/onboarding/StartScreen";
import TransitionWrapper from "@/components/TransitionWrapper";
import LoadingSplashScreen from "@/components/onboarding/LoadingSplashScreen";
import { landlordDataAtom } from "@/recoil/atom/landlordDataAtom";
import { onboardingFormDataAtom } from "@/recoil/atom/onboardingFormDataAtom";
import RejectedScreen from "@/components/journey/RejectedScreen";
import config from "@/config";

// Below Images I am preloading - Doing the same on start Screen
// import image1 from "@/assets/images/landlord-work2.svg";
// import image2 from "@/assets/images/tenant-work.svg";
// import image3 from "@/assets/images/LandlordBene.svg";
// import image4 from "@/assets/images/tenant-tile.svg";
// import image5 from "@/assets/images/landlord-tile.svg";

export default function DynamicHomeScreen() {
  const location = useLocation();
  const navigate = useNavigate();
  const token = localStorage.getItem(config.LOCAL_KEYS.SIGNUP_TOKEN);
  const user_identifier = localStorage.getItem("user_identifier");

  const searchParams = new URLSearchParams(location.search);
  const hashValue = window?.location?.hash
    ? window.location.hash.slice(1).split("?")[0]
    : "";

  const raw_query =
    new URLSearchParams(new URL(window?.location.href).search) || "hahaha";

  const queryObject = {};
  const queryStr = Array.from(raw_query.entries())
    .map(([key, value]) => `${key}=${value}`)
    .join("&");

  raw_query.forEach((value, key) => {
    queryObject[key] = value;
  });

  let utmSource, utm_campaign, utm_channel, fbcl_id, rf_code;

  if (searchParams) {
    utmSource = searchParams.get("utm_source");
    utm_campaign =
      searchParams.get("utm_id") || searchParams.get("utm_campaignid");
    utm_channel = searchParams.get("c");
    fbcl_id = searchParams.get("fbclid");
    rf_code = searchParams.get("rf_code");
  }

  useEffect(() => {
    if (utmSource) localStorage.setItem("UTM_SOURCE", utmSource);
    if (utm_campaign) localStorage.setItem("UTM_CAMPAIGN", utm_campaign);
    if (utm_channel) localStorage.setItem("UTM_CHANNEL", utm_channel);
    if (fbcl_id) localStorage.setItem("FBCL_ID", fbcl_id);
    if (hashValue) {
      localStorage.setItem("UTM_CHANNEL", hashValue);
    }
    if (queryStr) {
      localStorage.setItem("QUERY_STR", queryStr);
    }
    if (rf_code) {
      localStorage.setItem("RF_CODE", rf_code);
    }
  }, []);

  const [userData, setUserData] = useRecoilState(userDataAtom);
  const [, setLandlordData] = useRecoilState(landlordDataAtom);
  const [, setFormData] = useRecoilState(onboardingFormDataAtom);
  const [loading, setLoading] = useState(false);
  const [isFetched, setIsFetched] = useState(false);

  useEffect(() => {
    setFormData({});
  }, []);

  useEffect(() => {
    const getUserData = async () => {
      try {
        setLoading(true);
        const data = await fetchData("user/me");
        setLandlordData(data?.landlord);
        if (data) setUserData(data);
      } catch (error) {
        console.error("Failed to fetch user data:", error);
      } finally {
        setLoading(false);
      }
    };

    // Check if data should be fetched
    if (!token && !user_identifier) {
      navigate("/sign-up");
      return;
    }

    if (
      !isFetched && // Check fetch flag
      (!userData?.phone || userData?.approval?.length === 0) // Validate condition
    ) {
      getUserData();
      setIsFetched(true); // Prevent further fetching
    }
  }, [
    setLandlordData,
    setUserData,
    userData?.phone,
    userData?.approval,
    isFetched,
    token,
    user_identifier,
    navigate,
  ]);

  const propi = useLocation();
  const { shouldLoad, pass } = propi.state || { shouldLoad: true };

  // const preloadImages = () => {
  //   const images = [image1, image2, image3, image4, image5];

  //   images.forEach((src) => {
  //     const img = new Image();
  //     img.src = src;
  //   });
  // };

  // useEffect(preloadImages, []);

  useEffect(() => {
    if (userData)
      trackPageView(
        "Complete Journey Nudge",
        `${
          userData.isEligible !== null
            ? "Home Screen - Eligibilty Check Done"
            : "Home Screen - Eligibilty check yet to be done"
        }`
      );
  }, [userData]);

  useEffect(() => {
    if (userData)
      trackPageView(
        "Check Eligibilty Nudge",
        `${
          userData?.landlord &&
          Array.isArray(userData?.landlord) &&
          userData.landlord.length > 0
            ? "Home Screen - Journey Completed"
            : "Home Screen - Journey yet to be completed"
        }`
      );
  }, [userData]);

  if (shouldLoad) {
    if (loading) {
      return <LoadingSplashScreen />;
    }
  }

  if (loading) {
    return <LoadingSplashScreen />;
  }

  if (userData?.phone) {
    // console.log("jouney my: ",userData.journey);
    if( userData?.journey?.length < 1 ){
      console.log("navigate to rediect");
      navigate("/redirect")
      return
    }
    if (userData.leadType === "landlord") {
      return (
        <TransitionWrapper>
          <RejectedScreen
            isLandlord={true}
            showBackButton={location?.state?.from === "update-landlord"}
          />
        </TransitionWrapper>
      );
    }

    // if (!pass && userData.isEligible === false) {
    //   return (
    //     <TransitionWrapper>
    //       <RejectedScreen />
    //     </TransitionWrapper>
    //   );
    // }

    return (
      <TransitionWrapper>
        <NewHomeScreen />
      </TransitionWrapper>
    );
  } else {
    return (
      <TransitionWrapper>
        <StartScreen />
      </TransitionWrapper>
    );
  }
}
